import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bsc-computer-science-course',
  templateUrl: './bsc-computer-science-course.component.html',
  styleUrls: ['./bsc-computer-science-course.component.scss']
})
export class BscComputerScienceCourseComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;


  ngOnInit(): void {
  }

}
